import { useEffect } from 'react';
export function useOnVisible(ref, callback, options) {
    useEffect(() => {
        const el = ref.current;
        const observer = new IntersectionObserver(([entry]) => {
            callback(entry.isIntersecting);
        }, options);
        if (el) {
            observer.observe(el);
        }
        return () => {
            if (el) {
                observer.unobserve(el);
            }
        };
    }, [ref, callback, options]);
}
//# sourceMappingURL=useOnVisible.js.map